export class ConfirmDialogInputModel {
    header: string;
    content: string;
    confirmText? : string;
    cancelText? : string;
    showCancelBtn? : boolean = true;
    disableClose? : boolean;
}
